<script>
import { mapActions, mapGetters } from 'vuex';
import { fetchQuotationRequests,  } from "@/api/quotation";
import { pages } from '@/entities/current-page';
import Pagination from '@/components/Pagination';
import RowBlockSkeleton from "@/views/quotations/components/RowBlockSkeleton";
// import displaySettings from "@/mixin/displaySettings";
import Breadcrumbs from "@/shared/ui/breadcrumbs/breadcrumbs/index.vue";
import { PageTitle } from '@/shared/ui/page-title';
import { ChatIcon } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';
import ChatBtn from "@/components/app/quotation/ChatBtn.vue";
import { userMixin, partnerMixin } from '@/mixin';

export default {
	name: "QuotationsList",
	components: {RowBlockSkeleton, Pagination, Breadcrumbs, PageTitle, ChatIcon, SmartLink, ChatBtn },
	mixins: [userMixin],
  props: {
    isLoadData: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    isMobile: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    quotations: {
      type: Array,
      default: () => {
        return [{
          fullName: null,
          quotationTypeId: null,
          status: null,
          userId: null,
          comment: null,
          company: null,
          createdAt: null,
        }];
      },
    },
  },
	data() {
		return {
			data: [],
			meta: {},
      total: 1,
			loading: false,
      listQuery: {
        statusId: null,
      },
      quotationStatusList: [
        { id: 0, name: 'Чернетка' },
        { id: 1, name: 'Новий' },
        { id: 2, name: 'В обробці' },
        { id: 3, name: 'Потрібна додаткова інформація' },
        { id: 4, name: 'Пропозиція' },
        { id: 5, name: 'Обрано пропозицію' },
        { id: 6, name: 'Оформлено' },
        { id: 7, name: 'Відхилено' },
      ],
      showChatPopover: false,
      quotationRequestId: null,
      breadcrumbs: [
        {
          title: 'Головна',
        },
        {
          title: 'Центр котирування',
        },
      ],
		}
	},
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  watch: {
    'listQuery.statusId': function (newValue, oldValue) {
      this.$emit('init-quotations-list', 1);
    }
  },
	methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
		getData() {
			this.loading = true;
      fetchQuotationRequests().then(response => {
				this.data = response.data.data?.items;
				this.total = response.data.data?.total;
				this.loading = false;
			})
		},
		getStatusName(type) {
			switch (type) {
				case 'pending':
					return 'Очікує подання';
				case 'in_work':
					return 'В роботі'
				case 'reissued':
					return 'Переоформлений'
				case 'rejected':
					return 'Відхилений'
				default:
					return '';
			}
		},
    getQuotationStatuses() {
      return this.quotationStatusList;
    },
    activateTab: function (status) {
      const statusId = status?.id ?? null
      this.$set(this.listQuery, 'statusId', statusId);
      //this.$emit('change-tab', status)
    },
    activateTabMobile: function (status) {
      const statusId = status ?? null
      this.$set(this.listQuery, 'statusId', statusId);
    },
    isStatusDraft(item) {
      return item.status == 0;
    },
    showChat(rowData) {
      this.quotationRequestId = rowData.id;
      this.showChatPopover = true;
    },
    hide: function () {
      return this.showChatPopover = false;
    },
    handle: function (rowData) {
      //return this.condition.isShow = ! this.condition.isShow
      this.quotationRequestId = rowData.id;
      return this.showChatPopover = !this.showChatPopover;
    }
	},
	mounted() {
		//this.getData();
	}
}
</script>

<template>
	<div class="quotation-page quotations-list container p-0">

    <div v-if="! isMobile" class="tabs-block">
      <ul class="status-tabs">
        <li @click="activateTab(null)" class="tab">
          <a v-bind:class="{ active: listQuery.statusId == null }"
             href="javascript:void(0);"> {{ 'Всі' }}</a>
        </li>
        <li @click="activateTab(status)" v-for="(status, index) in getQuotationStatuses()" class="tab">
          <a v-bind:class="{ active: listQuery.statusId === status.id}"
             href="javascript:void(0);"> {{ status.name || 'Всі' }}</a>
        </li>
      </ul>
    </div>
    <div v-else>
      <div v-if="isMobile" class="row form-group">
        <el-select v-model="listQuery.statusId"
                   class="form-control-el tabs-mobile-select select-prolong-tab"
                   popper-class="select-prolong-tab-list"
                   @change="activateTabMobile"
                   placeholder="Виберіть статус"

        >
          <el-option v-for="item in getQuotationStatuses()"
                     :key="item.id"
                     :label="item.name || 'Всі'"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>

		<div v-if="isMobile">
      <div class="mobile-quotations-list">
        <!-- data -->
        <div v-for="item in quotations" :key="item.id" class="mobile-reissue-list-item">
          <div class="row order-data">

            <div class="row-mobile first-row">
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Назва</div>
                  <div class="option-value">{{ item.quotationTypeName }}</div>
                </div>
              </div>
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">ID запиту</div>
                  <div class="option-value">
                    <div class="option-value">{{ item.id }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row-mobile first-row">
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Статус</div>
                  <div class="option-value">
                    <div class="option-value">
                      <div :class="['status', `status-${item.status}`]">
                        <span>{{ item.statusName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Дата створення</div>
                  <div class="sub-options">
                    <div>
                      <span class="option-value name-wrap">{{ item.createdAt }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row-mobile first-row">
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Кількість пропозицій</div>
                  <div class="option-value">{{ item.propositionsCount }}</div>
                </div>
              </div>
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Дії</div>
                  <div class="option-value">
                    <div class="option-value">
                      <SmartLink v-if="isStatusDraft(item)" class="renewals-list__link" :route="{name: 'quotation-search',params: { id: item.id }}">
                        Продовжити
                      </SmartLink>
                      <SmartLink v-else class="renewals-list__link" :route="{ name: 'quotation-info', params: { id: item.id } }">
                        Детальніше
                      </SmartLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row-mobile first-row">

              <div v-if="!isPartner()" class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Підточка</div>
                  <div class="option-value">
                    {{ getUserId() !== item.userId ? item.userFullName : '-' }}
                  </div>
                </div>
              </div>
              
              <div class="col-6 half-block">
                <div class="info-block">
                  <div class="option-title">Чат</div>
                  <div class="option-value">
                    <chat-btn :quotation-request-id="item.id" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>

		<div v-else class="quotations-list">
      <div class="container-wrapp">
        <div class="header-block">
          <ul class="columns-block">
            <li class="column">Назва продукту</li>
            <li class="column">Статус</li>
            <li class="column">ID Запиту</li>
            <li v-if="!isPartner()" class="column">Підточка</li>
            <li class="column">Дата створення</li>
            <li class="column">Кількість пропозицій</li>
            <li class="column">Дії</li>
            <li class="column">Чат</li>
          </ul>
        </div>
        <div v-if="loading">
          <row-block-skeleton v-for="item in 4" :key="item"/>
        </div>
        <div v-else>
          <div class="row-block" v-for="item in quotations">
            <ul class="columns-block">

              <li class="column">
                <el-col>
                  <div class="option-result">{{ item.quotationTypeName }}</div>
                </el-col>
              </li>

              <li class="column">
                <el-col class="right-border">
                  <div class="d-flex align-middle">
                    <div :class="['status', `status-${item.status}`]">
                      <span>{{ item.statusName }}</span>
                    </div>
                  </div>
                </el-col>
              </li>

              <li class="column">
                <el-row>
                  <el-col>
                    <div class="option-result">{{ item.id }}</div>
                  </el-col>
                </el-row>
              </li>

              <li v-if="!isPartner()" class="column">
                <el-row>
                  <el-col>
                    <div class="option-result">{{ getUserId() !== item.userId ? item.userFullName : '-' }}</div>
                  </el-col>
                </el-row>
              </li>

              <li class="column">
                <el-row>
                  <el-col>
                    <div class="option-result">{{ item.createdAt }}</div>
                  </el-col>
                </el-row>
              </li>

              <li class="column">
                <el-row>
                  <el-col>
                    <div class="option-result">{{ item.propositionsCount }}</div>
                  </el-col>
                </el-row>
              </li>

              <li class="column">
                <el-row>
                  <el-col>
                    <div class="option-result">
                      <SmartLink v-if="isStatusDraft(item)" class="renewals-list__link" :route="{name: 'quotation-search',params: { id: item.id }}">
                        Продовжити
                      </SmartLink>
                      <SmartLink v-else class="renewals-list__link" :route="{ name: 'quotation-info', params: { id: item.id } }">
                        Детальніше
                      </SmartLink>
                    </div>
                  </el-col>
                </el-row>
              </li>

              <li class="column">
                <el-row>
                  <el-col>
                    <div class="option-result">
                      <chat-btn :quotation-request-id="item.id" />
                    </div>
                  </el-col>
                </el-row>
              </li>
            </ul>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>

<style lang="scss">
@import "./styles/quotations";
</style>
<style scoped>
* >>> .el-collapse-item__header {
	height: auto;
	line-height: unset;
	&:nth-child(2n+1) {
		background: #F6F7FB;
	}
}
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
//margin-bottom: 26px !important;
}
span {
	color:#999DA6;
}
</style>
